import axios from 'axios';
import { setupAxios } from '@carvana/core-auth';

const createAxiosInstance = ({
  timeout = 10000,
  ...rest
}: { timeout?: number; [key: string]: unknown } = {}) => {
  const instance = axios.create({
    timeout,
    ...rest
  });

  return setupAxios(instance, { addBearerTokenToAllRequests: true });
};

const axiosWithAuth = (options: { timeout?: number; [key: string]: unknown } = {}) =>
  createAxiosInstance(options);

export default axiosWithAuth;
